import { useTranslation } from 'react-i18next'

import { Form } from 'app/common/presentation'
import { useUser } from 'app/user/application'

const AccessSettings = () => {
  const { t } = useTranslation('settings')
  const { workspace } = useUser()

  return (
    <>
      <Form.InputFormRow
        description={t('access.workspaceId.description')}
        title={t('access.workspaceId.title')}
        value={workspace.id}
      />
      <Form.InputFormRow
        description={t('access.apiSecret.description')}
        title={t('access.apiSecret.title')}
        value={workspace.apiKey}
      />
    </>
  )
}

export default AccessSettings
